Flup.init(function (flup) {
    const $addBrandButton = $(".add-brand-button")
    const $brandAddFormContainer = $(".add-brand-form-container")
    const $brandAddCountrySelect = $(".brand-add-country-select")
    const $brandTypeSelect = $("#brand-type-select")
    const $brandNameInput = $("#brand-name-input")
    const $brandNameInputValue = $brandNameInput.val()

    $brandAddFormContainer.hide()
    $brandAddCountrySelect.select2()
    
    const disableBrandNameInput = () => {
        let disableBrandNameInput = $brandTypeSelect.val() === "figurative"
        $brandNameInput.prop( "disabled", disableBrandNameInput )
        disableBrandNameInput ? $brandNameInput.val("") : $brandNameInput.val($brandNameInputValue)
    }

    $addBrandButton.click(function(e){
        $brandAddFormContainer.toggle()
        $brandAddFormContainer.is(":visible") ? $addBrandButton.html("OCULTAR FORMULARIO") : $addBrandButton.html("AGREGAR MARCA")
    }) 
    
    $brandTypeSelect.change(function(e){
        disableBrandNameInput()
    })
    
})